const PROJECT_ID = 'cifo3gax';
const DATASET = 'production';
const API_VERSION = '2024-01-01';

export async function fetchSanity(query, params = {}) {
  const searchParams = new URLSearchParams({ query });
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(`$${key}`, JSON.stringify(value));
  });

  const url = `https://${PROJECT_ID}.api.sanity.io/v${API_VERSION}/data/query/${DATASET}?${searchParams}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Sanity fetch failed: ${response.status}`);
  const data = await response.json();
  return data.result;
}
